import magento2 from "./magento2";
import contentful from "./contentful";
import prismic from "./prismic";
import magento1 from "./magento1";
import openmage from "./openmage";
import appSources from "./app-sources";

export default [
  magento2,
  contentful,
  prismic,
  magento1,
  openmage,
  ...appSources,
].filter(Boolean);
